import req from "../../../services/psikotest/request";

class IstGesamtNormaIq {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/ist_gesamt_norma_iq/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSIstGesamtNormaIq) {
    try {
      const res = await req.post("/api/psikotest_system/ist_gesamt_norma_iq/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSIstGesamtNormaIq) {
    try {
      const res = await req.put("/api/psikotest_system/ist_gesamt_norma_iq/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/ist_gesamt_norma_iq/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default IstGesamtNormaIq;
